import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const GroupFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M19.82 5.42C19.82 7.06 18.5 8.36 16.86 8.36C15.22 8.36 13.9 7.06 13.9 5.42C13.9 3.78 15.22 2.48 16.86 2.48C18.5 2.48 19.82 3.78 19.82 5.42ZM10.1 9.62C10.1 11.26 8.78 12.56 7.14 12.56C5.5 12.56 4.18 11.26 4.18 9.62C4.18 7.98 5.5 6.68 7.14 6.68C8.78 6.68 10.1 7.98 10.1 9.62ZM16.86 9.14C19.78 9.14 22 11.6 22 14.8H11.72C11.72 11.6 13.94 9.14 16.86 9.14ZM7.14 13.34C10.06 13.34 12.28 15.8 12.28 19H2C2 15.8 4.22 13.34 7.14 13.34Z" />
    </SvgIcon>
  );
});
